import type { z } from "zod";
import { firstPlanSchema, profileDetailSchema, referenceCountsSchema } from "@amber/profiles/contracts";

export const profilePageSchema = profileDetailSchema.extend({
  first_plan: firstPlanSchema.nullable(),
  references: referenceCountsSchema.nullable(),
});
export type ProfilePage = z.infer<typeof profilePageSchema>;
